var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "501.762px",
    height: "409.26px",
    viewBox: "0 0 501.762 409.26",
    enableBackground: "new 0 0 501.762 409.26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M217.329,220.458c-8.219,0,34.192-0.008,34.192-0.008V150h-73.756c0,0-0.153,46.913,0,64.867 c0.022,2.61,26.447,49.688,26.447,49.688s8.577,0,13.116,0V220.458z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -1875.377,
    y: -9358.039,
    width: 4276.708,
    height: 16829.355
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 164.969,
    y: 137.272,
    clipPath: "url(#SVGID_4_)",
    fill: "#FAA31B",
    width: 99.281,
    height: 140.012
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M311.518,220.458c-8.218,0,34.193-0.008,34.193-0.008V150h-73.755c0,0-0.153,46.913,0,64.867 c0.021,2.61,26.446,49.688,26.446,49.688s8.578,0,13.116,0V220.458z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -1875.377,
    y: -9358.039,
    width: 4276.708,
    height: 16829.355
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 259.158,
    y: 137.272,
    clipPath: "url(#SVGID_8_)",
    fill: "#FAA31B",
    width: 99.282,
    height: 140.012
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoet);
export default __webpack_public_path__ + "static/media/quoet.8ee47c9aa9c58a1a4515921382ca0bea.svg";
export { ForwardRef as ReactComponent };